/**
 * An idle logout is recorded in login_history by the browser client. RLS only accepts that row from a
 * live session (user_id = auth.uid()); after the idle timeout the access token has usually expired, the
 * request runs as anon and is rejected with a 401. Only try to record it while the session is still valid.
 */
export function canRecordIdleLogout(
  session: { expires_at?: number | null } | null | undefined,
  nowMs: number,
): boolean {
  if (!session || typeof session.expires_at !== 'number') return false;
  return session.expires_at * 1000 > nowMs;
}
